export default "__VITE_ASSET__OXuKqhdn__"